import {useCallback} from "react";
import {useSelector} from "react-redux";
import {getEventFieldTypesList} from "../../../redux/Selectors/eventRule.selector";

export const useEventTypeLabels = () => {
  const eventFieldTypes = useSelector(getEventFieldTypesList);

  return useCallback(
    (eventTypes) =>
      (Array.isArray(eventTypes) ? eventTypes : []).map((eventType) => {
        const match = eventFieldTypes?.find((option) => option.value === eventType);
        return match?.label ?? eventType;
      }),
    [eventFieldTypes]
  );
};
